import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import RadioFieldGroup from 'components/shared/RadioFieldGroup';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';

const RsvpType = ({ onChange, value }) => (
  <div className="NewEventForm-sessionForm mb-40">
    <div className="mb-4">{t('in_person_training.new_event.rsvp_label')}</div>
    <RadioFieldGroup
      className="ml-12"
      name="rsvpTypeOptions"
      selectedValue={value}
      onChange={onChange}
    >
      <RadioField value="single">
        {t('in_person_training.new_event.rsvp_radio_single_label')}
        <Text variant={TEXT_VARIANTS.BODY_LIGHT} component="div">
          <span className="fz-14">
            {t('in_person_training.new_event.rsvp_radio_single_option')}
          </span>
        </Text>
      </RadioField>
      <RadioField value="all">
        {t('in_person_training.new_event.rsvp_radio_all_label')}
        <Text variant={TEXT_VARIANTS.BODY_LIGHT} component="div">
          <span className="fz-14">
            {t('in_person_training.new_event.rsvp_radio_all_option')}
          </span>
        </Text>
      </RadioField>
    </RadioFieldGroup>
  </div>
);

export default RsvpType;
